// extracted by mini-css-extract-plugin
var _1 = "modalNotifications-module_agreement__j7qpdW";
var _2 = "modalNotifications-module_captchaContainer__jE7wC5";
var _3 = "modalNotifications-module_contentText__nZF636";
var _4 = "modalNotifications-module_dialogActions__iKYSaU";
var _5 = "modalNotifications-module_dialogContnent__fhFuUf";
var _6 = "modalNotifications-module_dialog_paper__PQysg0";
var _7 = "modalNotifications-module_dialog_title__Ds6dNJ";
var _8 = "modalNotifications-module_imgContainer__OdYJdQ";
var _9 = "modalNotifications-module_input__b9KULP";
var _a = "modalNotifications-module_notificationCheckbox__hPzf_7";
export { _1 as "agreement", _2 as "captchaContainer", _3 as "contentText", _4 as "dialogActions", _5 as "dialogContnent", _6 as "dialog_paper", _7 as "dialog_title", _8 as "imgContainer", _9 as "input", _a as "notificationCheckbox" }
